module.exports = __webpack_public_path__ + "fonts/Inter-100-cyrillic5.fbe36d9.woff2";